import { Button } from "@/components/ui/button";
import { Question } from "@phosphor-icons/react";

export default function TourHelpButton({ onClick }) {
  return (
    <Button variant="outline" size="sm" onClick={onClick} data-testid="tour-help-btn">
      <Question size={16} weight="bold" className="mr-1.5" /> Cómo funciona
    </Button>
  );
}
